export default class ManagerRegions {
	constructor(section) {
		const managerSelect =
			section.querySelector('select[name="manager_regions[manager_id]"]');

		managerSelect.onchange = function() {
			window.location.href = window.location.pathname +
				'?' + 'manager_regions[manager_id]=' + managerSelect.value;
		};
	}
}
